import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function titleReducer(state = initialState.titles, action) {
    switch(action.type){

        case types.SET_PROJECT_TITLE:
            return Object.assign({},state,
                {
                    projectTitle: action.projectTitle
                }
            );
        case types.SET_BITE_TITLE:
            return Object.assign({},state,
                {
                    biteTitle: action.biteTitle
                }
            );
        case types.SET_SCREEN_TITLE:
            return Object.assign({},state,
                {
                    screenTitle: action.screenTitle
                }
            );
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/titleReducer.js
 **/